import { getStatusColorWithOpacity } from '../../constants/statusColors';

export function getProgramColor(program) {
  return getStatusColorWithOpacity(program?.status, 0.8);
}

export function getSegmentedColors(program, completionStatus = null) {
  // Always use white background with green fill based on completion percentage
  let percentage = 0;
  
  // If completion status is available, get the percentage
  if (completionStatus && typeof completionStatus === 'object' && 'completionPercentage' in completionStatus) {
    percentage = Math.min(100, Math.max(0, completionStatus.completionPercentage || 0));
  }
  
  // Always return percentage-based rendering (white background, green fill)
  return {
    usePercentage: true,
    percentage: percentage,
    completedColor: '#4CAF50', // Green color
    pendingColor: '#FFFFFF' // White color
  };
}



